export default (inputUrl) => {
  try {
    const url = new URL(inputUrl);
    return url.protocol === 'https:';
  } catch (_) {
    return false;
  }
};
